import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { IMultiTenantLogin2FARequest } from './interfaces/request'
import { IMultiTenantLogin2FAResponse } from './interfaces/response'

export const MultiTenantLogin2FAService = async (
  request: IMultiTenantLogin2FARequest,
): Promise<IMultiTenantLogin2FAResponse> => {
  const response = await apiClient.post(
    'api/Login/MultiTenantLogin2FA',
    request,
    {
      baseURL: process.env.NEXT_PUBLIC_API_BACKEND_URL,
    },
  )

  return response?.data
}

export const useMultiTenantLogin2FAService = (): UseMutationResult<
  IMultiTenantLogin2FAResponse,
  Error,
  IMultiTenantLogin2FARequest
> => {
  return useMutation<
    IMultiTenantLogin2FAResponse,
    Error,
    IMultiTenantLogin2FARequest
  >({
    mutationFn: async (request) => {
      const response = await apiClient.post(
        'api/Login/MultiTenantLogin2FA',
        request,
      )

      return response.data
    },
  })
}

export type { IMultiTenantLogin2FARequest, IMultiTenantLogin2FAResponse }
